import type { SYSTableDef } from "../../../../../../../_ovlclient/src/library/table/tableapi"

export let tblPackaging: SYSTableDef = {
  id: "PKGPackaging",
  feature: "PKGPackaging",
  database: {
    dataIdField: "Code",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "packaging",
  },
  options: {
    initial_paging: { page: 0, pageSize: 200 },
    edit: { editType: "inline" },
    initial_sort: { field: "DocNum", direction: "asc" },
    initial_filterCustom: {
      ovld: {
        filters: {
          NotFinished: {
            active: true,
            translationKey: "PKGPackagingPackagingFilterNotFinished",
            showInTitle: false,
          },
        },
      },
    },
    customRowActions: {
      PrintLabel: {
        icon: "sap-icon--print",
        translationKey: "PKGPackagingPackagingPrintLabel",
      },
      OpenSplit: {
        icon: "sap-icon--split",
        translationKey: "PKGPackagingPackagingSplit",
      },
      UnSplit: {
        icon: "sap-icon--combine",
        translationKey: "PKGPackagingPackagingUnSplit",
      },
    },
  },

  features: {
    page: true,
    edit: true,
    filter: true,
  },

  columns: {
    DocNum: {
      sortable: true,

      ui: {
        readonly: true,
        labelTranslationKey: "PKGPackagingPackagingDocNum",
      },
      filter: { columnFilter: { type: "none" } },
    },
    DocComments: {
      ui: {
        readonly: true,
        labelTranslationKey: "PKGPackagingPackagingOrderComments",
      },
    },
    U_Unit: {
      sortable: true,

      ui: {
        readonly: true,
        labelTranslationKey: "PKGPackagingPackagingUnit",
      },
    },
    U_WrapHeight: {
      type: "int",
      ui: { labelTranslationKey: "PKGPackagingPackagingWrapHeight" },
    },
    U_WrapWidth: {
      type: "int",
      ui: { labelTranslationKey: "PKGPackagingPackagingWrapWidth" },
    },
    U_WrapLength: {
      type: "int",
      ui: { labelTranslationKey: "PKGPackagingPackagingWrapLength" },
    },
  },
}
